import { useEffect, useState } from 'react'
import orderBy from 'lodash/orderBy'
import { db } from '../../../config/firebase'
import mapAmeCampaignListItem from './mapAmeCampaignListItem'
import { PROMO_CAMPAIGNS_COLLECTION } from './ameCampaignConstants'

const SUBSCRIPTION_ERROR_MESSAGE = 'Не вдалося завантажити акції Ame'

const useAmeCampaignsSubscription = () => {
  const [campaigns, setCampaigns] = useState([])
  const [brandsById, setBrandsById] = useState({})
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState('')

  useEffect(() => {
    let cancelled = false
    const loadBrands = async () => {
      try {
        const snap = await db.collection('brands').get()
        if (cancelled) return
        const next = {}
        snap.docs.forEach((doc) => {
          next[doc.id] = { id: doc.id, ...(doc.data() || {}) }
        })
        setBrandsById(next)
      } catch (brandsError) {
        console.error('[useAmeCampaignsSubscription] brands failed:', brandsError)
      }
    }
    loadBrands()
    return () => {
      cancelled = true
    }
  }, [])

  useEffect(() => {
    const unsubscribe = db.collection(PROMO_CAMPAIGNS_COLLECTION).onSnapshot(
      (snapshot) => {
        const nextCampaigns = orderBy(
          snapshot.docs.map((doc) => mapAmeCampaignListItem(doc.id, doc.data(), { brandsById })),
          ['updatedAtSort'],
          ['desc']
        )
        setCampaigns(nextCampaigns)
        setError('')
        setIsLoading(false)
      },
      (snapshotError) => {
        console.error('[useAmeCampaignsSubscription] failed:', snapshotError)
        setError(snapshotError?.message || SUBSCRIPTION_ERROR_MESSAGE)
        setIsLoading(false)
      }
    )

    return () => unsubscribe()
  }, [brandsById])

  return {
    campaigns,
    isLoading,
    error,
  }
}

export default useAmeCampaignsSubscription
